import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

const GetProcessStages = urlConfig.GetProcessStages;
const GetColumnHeaderSelection = urlConfig.GetColumnHeaderSelection;
const GetMetadataSelection = urlConfig.GetMetadataSelection;
const ColumnHeaderSelection = urlConfig.ColumnHeaderSelection;
const Useractivity = urlConfig.Useractivity;

export const getProcessStages = async (params: any) => {
  try {
    const response = await postCall(GetProcessStages, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getColumHeadersSelections = async (params: any) => {
  try {
    const response = await postCall(GetColumnHeaderSelection, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getMetaDataSelection = async (params: any) => {
  try {
    const response = await postCall(GetMetadataSelection, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const saveColumnHeaderSelection = async (params: any) => {
  try {
    const response = await postCall(ColumnHeaderSelection, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const userActivity = async (params: any) => {
  try {
    const response = await postCall(Useractivity, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
